import { string } from 'prop-types'
import { connectRefinementList } from 'react-instantsearch-dom'

import RefinementList from 'views/components/organisms/AlgoliaInstantSearch/Algolia/RefinementList'

import { updateOptionLabels } from './helpers'

const PrescriptionTypesFilter = ({
  items,
  trueOptionLabel,
  falseOptionLabel,
  ...rest
}) => {
  const labels = items.map(item => item.label)
  const props = { ...rest }
  if (
    items.length === 2 &&
    labels.includes('true') &&
    labels.includes('false')
  ) {
    props.items = updateOptionLabels(items, trueOptionLabel, falseOptionLabel)

    return <RefinementList {...props} />
  }
  props.items = []
  return <RefinementList {...props} />
}

PrescriptionTypesFilter.propTypes = {
  ...RefinementList.propTypes,
  trueOptionLabel: string.isRequired,
  falseOptionLabel: string.isRequired,
}

PrescriptionTypesFilter.defaultProps = {
  ...RefinementList.defaultProps,
}

export default connectRefinementList(PrescriptionTypesFilter)
